import { gql, useMutation } from '@apollo/client';
import { CancellationReason } from '@app/constants/cancellationReasons';

const CANCEL_SUBSCRIPTION = gql`
  mutation CancelSubscription($subscriptionId: String!, $reason: String, $note: String) {
    cancelSubscription(subscriptionId: $subscriptionId, reason: $reason, note: $note)
  }
`;

export interface CancelSubscriptionInput {
  subscriptionId: string;
  // optionaler Kuendigungsgrund (constants/cancellationReasons.ts) und Freitext
  reason?: CancellationReason;
  note?: string;
}

export interface CancelSubscriptionResult {
  cancelSubscription: boolean;
}

export function useSubscriptionCancelMutation() {
  return useMutation<CancelSubscriptionResult, CancelSubscriptionInput>(CANCEL_SUBSCRIPTION);
}
